import React, { Suspense, lazy } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Layout from "./components/Layout";
import LoadingSpinner from "./components/ui/LoadingSpinner";

// Eager: shell + sign-in (most common first paint).
import Signin from "./pages/Signin/Signin";

// Route-level code splitting — keeps the main bundle under CRA's size hint.
const Verify = lazy(() => import("./pages/Verify/Verify"));
const Dashboard = lazy(() => import("./pages/Dashboard/Dashboard"));
const Adminstration = lazy(() => import("./pages/Adminstration/Adminstration"));
const UserManagement = lazy(() => import("./pages/UserManagement/UserManagement"));
const Notifications = lazy(() => import("./pages/Notifications/Notifications"));
const Companies = lazy(() => import("./pages/Companies/Companies"));
const CompanyFormPage = lazy(() => import("./pages/Companies/CompanyFormPage"));
const PotentialClients = lazy(() => import("./pages/PotentialClients/PotentialClients"));
const OrgHierarchy = lazy(() => import("./pages/OrgHierarchy/OrgHierarchy"));
const About = lazy(() => import("./pages/About/About"));
const Contact = lazy(() => import("./pages/Contact/Contact"));
const Privacy = lazy(() => import("./pages/Privacy/Privacy"));
const Terms = lazy(() => import("./pages/Terms/Terms"));

function RouteFallback() {
  return (
    <div className="flex min-h-[40vh] w-full items-center justify-center py-16">
      <LoadingSpinner />
    </div>
  );
}

const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        path: "/dashboard",
        element: <Dashboard />,
      },
      {
        path: "/companies",
        element: <Companies />,
      },
      {
        path: "/companies/new",
        element: <CompanyFormPage mode="create" />,
      },
      {
        path: "/companies/:companyId/edit",
        element: <CompanyFormPage mode="edit" />,
      },
      {
        path: "/potential-clients",
        element: <PotentialClients />,
      },
      {
        path: "/org-hierarchy",
        element: <OrgHierarchy />,
      },
      {
        path: "/adminstration",
        element: <Adminstration />,
      },
      {
        path: "/user-management",
        element: <UserManagement />,
      },
      {
        path: "/notifications",
        element: <Notifications />,
      },
    ],
  },
  {
    path: "/signin",
    element: <Signin />,
  },
  {
    path: "/verify",
    element: <Verify />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/privacy",
    element: <Privacy />,
  },
  {
    path: "/terms",
    element: <Terms />,
  },
]);

export default function MyRouter() {
  return (
    <Suspense fallback={<RouteFallback />}>
      <RouterProvider router={router} />
    </Suspense>
  );
}
